import { NavLink, Outlet } from 'react-router-dom';

// Wrapper for the donations section — three internal tabs on top,
// each child page renders its own header + body inside the Outlet:
//   - تقارير  → DonationsPage (campaign totals report)
//   - الإدارة → DonationCausesPage (donation causes + sub-options)
//   - السجل  → DonationsTransactionsPage (live donation log)
export default function DonationsWrapperPage() {
  const tab = (to: string, label: string) => (
    <NavLink to={to} end className={({ isActive }) => `home-tab ${isActive ? 'active' : ''}`}>
      {label}
    </NavLink>
  );

  return (
    <>
      <div className="home-tabs" role="tablist" aria-label="أقسام التبرعات">
        {tab('/donations/reports', 'تقارير التبرعات')}
        {tab('/donations/management', 'إدارة التبرعات')}
        {tab('/donations/transactions', 'سجل التبرعات')}
      </div>
      <div className="home-tab-panel">
        <Outlet />
      </div>
    </>
  );
}
